import { render, staticRenderFns } from "./88.vue?vue&type=template&id=16b3a912&scoped=true&"
var script = {}
import style0 from "./88.vue?vue&type=style&index=0&id=16b3a912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3a912",
  null
  
)

export default component.exports